const ERROR_TEMPLATES = ['WebshopFailedOrder', 'WebshopFailedPayment'];

export default defineNuxtPlugin(nuxtApp => {
	if (!__SENTRY_TRACKING__) return;
	const router = useRouter();
	let lastTrackedPage = null;

	const trackErrorTemplate = async to => {
		const template = to.meta?.template;
		if (!ERROR_TEMPLATES.includes(template)) return;
		const pageKey = `${template}:${to.fullPath}`;
		if (pageKey === lastTrackedPage) return;
		lastTrackedPage = pageKey;

		await nextTick();
		useSentryTracking().captureErrorPage(template, {route: to.path, template});
	};

	router.afterEach(trackErrorTemplate);
	router.isReady().then(() => trackErrorTemplate(router.currentRoute.value));
});
